import * as actionType from './pmpActions';
import { ApiGateWay } from '../../../ApiGateWay/ApiGateWay';
import { Config } from '../../../config/config';
import Cookie from 'js-cookie';
import LZString from 'lz-string';
const config = JSON.parse(Config);
const apiInterface = config['api1'];
console.log(apiInterface,'apiinterface')

const initialState = {
    message: '',
    modalOpen: false,
    loading: false,
    apiStatus:false,
}
export const apiCallStatus = (data) => (dispatch) => {
    dispatch(apiStatus(data))
}
export const apiStatus = (data) => ({
    type: actionType.API_CALL_STATUS,
    payload: data,
})
export const GetPMPList = (data) => ({
    type: actionType.GET_PMP_LIST,
    payload: data,
})
export const GetTechnicianList = (data) => ({
    type: actionType.GET_TECHNICIAN_LIST,
    payload: data,
})
export const GetPMPReportData = (data) => ({
    type: actionType.GET_PMP_REPORT_DATA,
    payload: data,
})
export const GetWorkRequestReportData = (data) => ({
    type: actionType.GET_WORKREQUEST_REPORT_DATA,
    payload: data,
})
export const ClearData = () => ({
    type: actionType.CLEAR_DATA,
})
export const PostPmpData = (data) => ({
    type:actionType.POST_PMP_DATA,
    payload:data,
})
export const PMPList = (data)=>({
    type:actionType.IS_PMP_PLANNER,
    payload:data
})
export const selectedDataInfo = (data)=>({
    type:actionType.SELECTED_DATA_INFO,
    payload:data
})
export const doGetPMPList= () => async (dispatch) => {
    const jsonData = Cookie.get('currentUser');
    let decompressedData = LZString.decompressFromBase64(jsonData);
    decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
    const user = JSON.parse(decompressedData);
       const data = {
        'fedid': user['userId'],
    }
    initialState.loading = true;
    initialState.modalOpen=false;
    dispatch(apiCallStatus(initialState))
    ApiGateWay.SaveData(
        apiInterface +
        '/PMPInfo/loadallPMPInfo',data)
        .then((response) => {
            initialState.loading = false;
            if (response[0]?.Table1[0]?.status_code == '000') {
                const StoreList = response[1]?.Table2;
                const  VendorList= response[2]?.Table3;
                const ContractNameList = response[3]?.Table4;
                const SubCategoryList = response[4]?.Table5;
                const AssetList = response[5]?.Table6;
                const PMPList = response[6]?.Table7;
                const PMPHistory = response[7]?.Table8;
                const ExistingPMPList = response[8]?.Table9;
                const GroupPMPList = response[10]?.Table11;

                const PMPData = { StoreList, VendorList, ContractNameList, SubCategoryList, AssetList, PMPList, PMPHistory, ExistingPMPList,GroupPMPList}
                initialState.message = response[0]?.Table1[0]?.status_msg
                initialState.modalOpen = false
                dispatch(apiCallStatus(initialState))
                dispatch(GetPMPList(PMPData))
            } else {
                initialState.apiStatus=false
                initialState.loading = false;
                initialState.modalOpen = true;
                initialState.message = response[1]?.Table1[2]?.status_msg;
                dispatch(apiCallStatus(initialState))
                // console.log(response, 'response1')
            }
        })
        .catch((e) => {
            initialState.apiStatus=false
            initialState.loading = false;
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            // dispatch(apiCallStatus(initialState))
        })
}
export const SavePmpSchedule = (values) => async (dispatch) => {
    initialState.loading = true;
    dispatch(apiCallStatus(initialState))
    ApiGateWay.SaveData(apiInterface + '/PMPInfo/Createpmpplanner', values)
        .then((result) => {
            initialState.loading = false;
            if (result[0].Table1[0].status_code === '000') {
                initialState.message = result[0].Table1[0].status_msg
                initialState.apiStatus=true;
                initialState.modalOpen = true;
                dispatch(PostPmpData(initialState))
            }else{
                initialState.modalOpen = true;
                initialState.apiStatus=false;
                initialState.loading = false;
                initialState.message = result[1]?.Table1[2]?.status_msg
                dispatch(PostPmpData(initialState))
                // dispatch(APIStart(initialState)) 
            }
        })
        .catch(() => {
            initialState.loading = false;
            initialState.apiStatus=false
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            // dispatch(APIStart(initialState))
            dispatch(PostPmpData(initialState))

        })
}
export const SavePmpReSchedule = (values) => async (dispatch) => {
    initialState.loading = true;
    dispatch(apiCallStatus(initialState))
    ApiGateWay.SaveData(apiInterface + '/PMPInfo/ReschedulePMP', values)
        .then((result) => {
            initialState.loading = false;
            if (result[0].Table1[0].status_code === '000') {
                initialState.message = result[0].Table1[0].status_msg
                initialState.apiStatus=true;
                initialState.modalOpen = true;
                dispatch(apiStatus(initialState))
            }else{
                initialState.modalOpen = true;
                initialState.apiStatus=false;
                initialState.loading = false;
                initialState.message = result[1]?.Table1[2]?.status_msg
                // dispatch(APIStart(initialState))
                dispatch(apiStatus(initialState))
            }
        })
        .catch(() => {
            initialState.loading = false;
            initialState.apiStatus=false
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            // dispatch(APIStart(initialState))
            dispatch(apiStatus(initialState))


        })
}

export const CancelPmpPlanner = (values) => async (dispatch) => {
    initialState.loading = true;
    dispatch(apiStatus(initialState))
    ApiGateWay.SaveData(apiInterface + '/PMPInfo/CancelPMP', values)
        .then((result) => {
            initialState.loading = false;
            if (result[0].Table1[0].status_code === '000') {
                initialState.message = result[0].Table1[0].status_msg
                initialState.apiStatus=true;
                initialState.modalOpen = true;
                dispatch(apiStatus(initialState))

            }else{
                initialState.modalOpen = true;
                initialState.apiStatus=false;
                initialState.loading = false;
                initialState.message = result[1]?.Table1[2]?.status_msg
                dispatch(apiStatus(initialState))

            }
        })
        .catch(() => {
            initialState.loading = false;
            initialState.apiStatus=false
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            dispatch(apiStatus(initialState))
        })
}

export const acceptPlanner = (values) => async (dispatch) => {
    initialState.loading = true;
    dispatch(apiCallStatus(initialState))
    ApiGateWay.SaveData(apiInterface + '/PMPInfo/AcceptPMP', values)
        .then((result) => {
            initialState.loading = false;
            if (result[0].Table1[0].status_code === '000') {
                initialState.message = result[0].Table1[0].status_msg
                initialState.apiStatus=true;
                initialState.modalOpen = true;
                dispatch(apiStatus(initialState))

            }else{
                initialState.modalOpen = true;
                initialState.apiStatus=false;
                initialState.loading = false;
                initialState.message = result[1]?.Table1[2]?.status_msg
                dispatch(apiStatus(initialState))

            }
        })
        .catch(() => {
            initialState.loading = false;
            initialState.apiStatus=false
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            dispatch(apiStatus(initialState))
        })
}

export const GetTechnicianPMPList= () => async (dispatch) => {
    const jsonData = Cookie.get('currentUser');
          let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
          const user = JSON.parse(decompressedData);
        const data = {
        'fedid': user['userId'],
    }
    initialState.loading = true;
    // dispatch(apiCallStatus(initialState))
    ApiGateWay.SaveData(
        apiInterface +
        '/PMPInfo/LoadTechnician',data)
        .then((response) => {
            console.log(response,'responseData');
            initialState.loading = false;
            if (response[0]?.Table1[0]?.status_code == '000') {
                const TechnicianList = response[1]?.Table2;
                const technicianData = {TechnicianList}
                initialState.message = response[0]?.Table1[0]?.status_msg
                initialState.modalOpen = false
                dispatch(GetTechnicianList(technicianData))
                // dispatch(apiCallStatus(initialState))
            } else {
                initialState.apiStatus=false
                initialState.loading = false;
                initialState.modalOpen = true;
                initialState.message = response[0]?.Table1[0]?.status_msg;
                // dispatch(apiCallStatus(initialState))
                // console.log(response, 'response1')
            }
        })
        .catch((e) => {
            initialState.apiStatus=false
            initialState.loading = false;
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            // dispatch(apiCallStatus(initialState))
        })
}

export const AddTechnicianData = (values) => async (dispatch) => {
    initialState.loading = true;
    dispatch(apiCallStatus(initialState))
    ApiGateWay.SaveData(apiInterface + '/PMPInfo/AddTechnician', values)
        .then((result) => {
            initialState.loading = false;
            if (result[0].Table1[0].status_code === '000') {
                initialState.message = result[1].Table2[0].status_msg
                initialState.apiStatus=true;
                initialState.modalOpen = true;
                dispatch(apiStatus(initialState))

            }else{
                initialState.modalOpen = true;
                initialState.apiStatus=false;
                initialState.loading = false;
                initialState.message = result[1]?.Table2[0]?.status_msg
                dispatch(apiStatus(initialState))

            }
        })
        .catch(() => {
            initialState.loading = false;
            initialState.apiStatus=false
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            dispatch(apiStatus(initialState))
        })
}

export const DownloadPMPReports= (data) => async (dispatch) => {
    const jsonData = Cookie.get('currentUser');
          let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
          const user = JSON.parse(decompressedData);
    initialState.loading = true;
    dispatch(apiCallStatus(initialState))
    ApiGateWay.SaveData(
        apiInterface +
        '/PMPInfo/downloadpmpreports',data)
        .then((response) => {
            console.log(response,'downloadpmpreport');
            initialState.loading = false;
            if (response[0]?.Table1[0]?.status_code == '000') {
                initialState.message = response[0]?.Table1[0]?.status_msg
                initialState.modalOpen = false
                const PMPReportData = response[1].Table2
                const SubCategoryList = response[2].Table3;
                let info = {PMPReportData, SubCategoryList}
                dispatch(GetPMPReportData(info))
                dispatch(apiCallStatus(initialState))
            } else {
                initialState.apiStatus=false
                initialState.loading = false;
                initialState.modalOpen = true;
                initialState.message = response[0]?.Table1[0]?.status_msg;
                dispatch(apiCallStatus(initialState))
                // console.log(response, 'response1')
            }
        })
        .catch((e) => {
            initialState.apiStatus=false
            initialState.loading = false;
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            dispatch(apiCallStatus(initialState))
        })
}
export const DownloadWorkRequestReports= (data) => async (dispatch) => {
    const jsonData = Cookie.get('currentUser');
          let decompressedData = LZString.decompressFromBase64(jsonData);
          decompressedData = decompressedData =='\x00\x00\x00'?jsonData:decompressedData;
          const user = JSON.parse(decompressedData);
    initialState.loading = true;
    dispatch(apiCallStatus(initialState))
    ApiGateWay.SaveData(
        apiInterface +
        '/PMPInfo/downloadworkrequestreports',data)
        .then((response) => {
            console.log(response,'downloadpmpreport');
            initialState.loading = false;
            if (response[0]?.Table1[0]?.status_code == '000') {
                initialState.message = response[0]?.Table1[0]?.status_msg
                initialState.modalOpen = false
                const WorkRequestReportData = response[1].Table2
                const SubCategoryList = response[2].Table3;
                const info = {WorkRequestReportData, SubCategoryList}
                dispatch(GetWorkRequestReportData(info))
                dispatch(apiCallStatus(initialState))
            } else {
                initialState.apiStatus=false
                initialState.loading = false;
                initialState.modalOpen = true;
                initialState.message = response[0]?.Table1[0]?.status_msg;
                dispatch(apiCallStatus(initialState))
                // console.log(response, 'response1')
            }
        })
        .catch((e) => {
            initialState.apiStatus=false
            initialState.loading = false;
            initialState.modalOpen = true;
            initialState.message = 'Something went wrong please try again after sometime'
            dispatch(apiCallStatus(initialState))
        })
}